import { render, staticRenderFns } from "./list-components.vue?vue&type=template&id=3fb64948&"
import script from "./list-components.vue?vue&type=script&lang=js&"
export * from "./list-components.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports